import { documentNumberTranslations } from './document-number-i18n';
import { duplicationTranslations } from './duplication-i18n';
import { partnerMapTranslations } from './partner-map-i18n';
import { actionNeedTranslations } from './action-needs-i18n';
import { listViewTranslations } from './list-view-i18n';
import { pdfFieldCheckTranslations } from './pdf-field-check-i18n';
import { batchSelectionTranslations } from './batch-selection-i18n';
import { documentProgressTranslations } from './document-progress-i18n';
import { stockAdjustmentTranslations } from './stock-adjustment-i18n';
import { documentLockTranslations } from './document-lock-i18n';
import { portalRecoveryTranslations } from './portal-recovery-i18n';

import { priceGroupTranslations } from './price-group-i18n';
import { shippingTranslations } from '@erp/shared';
import { headerTranslations } from './header-i18n';
import { documentEntryTranslations } from './document-entry-i18n';
import { documentWorkspaceTranslations } from './document-workspace-i18n';
import { subdivisionTranslations } from './subdivision-i18n';
import { contactBriefingTranslations } from './contact-briefing-i18n';
import { internationalTranslations } from './international-i18n';
import { deliveryPlanningTranslations } from '@erp/shared';
import { introductionTranslations } from './introduction-i18n';
import { adminTr } from './admin-tr';
import { analyticsTr } from './analytics-tr';
import { dashboardTr } from './dashboard-i18n';
import { dmsTr } from './dms-tr';
import { partnersTr } from './partners-tr';
import { pdfDesignerTr } from './pdf-designer-tr';
import { procurementTr } from './procurement-tr';
import { settingsHubTr } from './settings-hub-tr';
import { telephonyTr } from './telephony-tr';
import { whatsAppTr } from './whatsapp-tr';
import { helpTr } from './help-tr';
import { feedbackTr } from './feedback-tr';
import { productSpecificationsTr } from './product-specifications-tr';
import { plmTr } from './plm-tr';
import { manufacturingTr } from './manufacturing-tr';
import { traceabilityTr } from './traceability-tr';
import { mrpTr } from './mrp-tr';
import { labelsTr } from './labels-tr';
import { changeControlTr } from './change-control-tr';
import { productDevelopmentDashboardTr } from './product-development-dashboard-tr';
import { searchTr } from './search-i18n';
import { vatValidationTr } from './vat-validation-i18n';
import { navigationTr } from './navigation-i18n';
import { dunningTr } from './dunning-i18n';
import { portalTr } from './portal-i18n';
import { productNewsTr } from './product-news-i18n';
import { newsletterTr } from './newsletter-i18n';
import { setupTr } from './setup-i18n';
import { importCenterTr } from './import-center-i18n';
import { bankingTr } from './banking-i18n';
import { translationGlossaryTr } from './translation-glossary-i18n';
import { salesAssistantTr } from './sales-assistant-i18n';
import { customerHeaderTr } from './customer-header-i18n';
import { featureAdminTr } from './feature-admin-i18n';

export const tr = {
  translation: {
    documentNumber: documentNumberTranslations.tr,
    duplication: duplicationTranslations.tr,
    partnerMap: partnerMapTranslations.tr,
    actionNeeds: actionNeedTranslations.tr,
    listViews: listViewTranslations.tr,
    pdfFieldCheck: pdfFieldCheckTranslations.tr,
    stockAdjustment: stockAdjustmentTranslations.tr,
    batchSelection: batchSelectionTranslations.tr,
    documentProgress: documentProgressTranslations.tr,
    documentLock: documentLockTranslations.tr,
    portalRecovery: portalRecoveryTranslations.tr,
    shipping: shippingTranslations.tr,
    priceGroups: priceGroupTranslations.tr,
    header: headerTranslations.tr,
    documentEntry: documentEntryTranslations.tr,
    documentWorkspace: documentWorkspaceTranslations.tr,
    ...contactBriefingTranslations.tr,
    international: internationalTranslations.tr,
    subdivision: subdivisionTranslations.tr,
    deliveryPlanning: deliveryPlanningTranslations.tr,
    introduction: introductionTranslations.tr,
    admin: { ...adminTr, dataHub: importCenterTr, features: featureAdminTr },
    analytics: analyticsTr,
    dms: dmsTr,
    portal: portalTr,
    productNews: productNewsTr,
    newsletter: newsletterTr,
    setup: setupTr,
    partners: partnersTr,
    pdfDesigner: pdfDesignerTr,
    procurement: procurementTr,
    settingsHub: settingsHubTr,
    telephony: telephonyTr,
    whatsapp: whatsAppTr,
    help: helpTr,
    feedback: feedbackTr,
    productSpecifications: productSpecificationsTr,
    plm: plmTr,
    manufacturing: manufacturingTr,
    traceability: traceabilityTr,
    mrp: mrpTr,
    labels: labelsTr,
    changeControl: changeControlTr,
    productDevelopmentDashboard: productDevelopmentDashboardTr,
    search: searchTr,
    vatValidation: vatValidationTr,
    dunning: dunningTr,
    banking: bankingTr,
    translationGlossary: translationGlossaryTr,
    paymentTerms: {
      netDays_one: '{{count}} net gün',
      netDays_other: '{{count}} net gün',
      discountPreview: '{{due}}, {{days}} gün içinde %{{percent}} iskonto',
      customLegacy: 'Bireysel eski koşul',
      search: 'Ödeme koşullarını ara…',
      noResults: 'Eşleşen ödeme koşulu bulunamadı.',
      loadError: 'Ödeme koşulları yüklenemedi.',
      warningCustom: 'Bu eski değerler yapılandırılmış bir kurala bağlı değil.',
      warningInconsistent: 'Eski değerler çelişkili. Geçerli bir ödeme koşulu seçin.',
      advanced: 'Bireysel ödeme değerleri',
      customAgreement: 'Bireysel anlaşma',
      selectionHint:
        'Ödeme vadesi ve erken ödeme iskontosu seçilen ödeme koşulundan otomatik alınır.',
      customHint:
        'Bu bireysel değerler katalog koşulunun yerine geçer. Yukarıdan bir koşul seçmek bu değerleri değiştirir.',
      customize: 'Bireysel koşul belirle',
      inconsistentValues:
        'İskonto süresi, iskonto ve ödeme vadesi birbiriyle çelişiyor. Değerleri kontrol edin veya bir ödeme koşulu seçin.',
      savedValues: 'Kayıtlı koşul · {{due}} · {{days}} gün içinde %{{percent}} iskonto',
    },
    addressResolution: {
      automatic: 'Otomatik belirlendi',
      adoptRegion: 'Önerilen {{region}} bölgesini kullan',
      importPlan: 'Onaylanan deneme işlemindeki bölge atamaları (elle girilen değerler korunur)',
      status: {
        RESOLVED: 'Bölge kesin olarak belirlendi.',
        INCOMPLETE: 'Beş haneli tam posta kodunu girin.',
        UNSUPPORTED: 'Bu ülke için otomatik bölge ataması mevcut değil.',
        NO_MATCH: 'Eşleşen belediye bulunamadı. Adresi kontrol edin veya bölgeyi elle girin.',
        CONFLICT: 'Şehir ile posta kodu eşleşmiyor. Adresi düzeltin veya bir belediye seçin.',
        AMBIGUOUS: 'Sonuçlar farklı bölgelere ait. Doğru belediyeyi seçin.',
        MISSING_REGION: 'İdari verilerde tam bölge bilgisi yok. Lütfen elle girin.',
        UNAVAILABLE: 'Bölge araması şu anda kullanılamıyor. Elle kaydetmeye devam edebilirsiniz.',
      },
      backfill: {
        title: 'Mevcut Fransız adreslerinin boş bölgelerini tamamla',
        hint: 'En fazla 50 adresin önizlemesi gösterilir. Kesin eşleşmeleri seçip onaylayın. Değiştirilen kayıtlar ve dolu bölgeler atlanır. Önizleme 30 dakika geçerlidir.',
        partners: 'Ana adresleri kontrol et',
        addresses: 'Diğer adresleri kontrol et',
        next: 'Sonraki grubu kontrol et',
        empty: 'Bölgesi boş başka Fransız adresi bulunamadı.',
        select: 'Tamamlamak için {{label}} seç',
        apply: 'Seçilen {{count}} tamamlamayı onayla',
        result: '{{updated}} tamamlandı; {{skipped}} değiştirildi veya zaten tamamlanmıştı.',
        error: 'İşlem başarısız oldu. Yeni bir önizleme oluşturup tekrar kontrol edin.',
      },
      loading: 'Şehir ve bölge aranıyor…',
      errorFallback: 'Konum araması kullanılamıyor. Bilgileri elle girin.',
      noResults: 'Eşleşen konum bulunamadı. Bilgileri elle girin.',
      useSuggestion: '{{value}} değerini kullan',
      choose: 'Şehir seçin',
      chooseCount: '{{count}} şehir bulundu — lütfen seçin',
      source: 'Kaynak: {{source}}',
      help: 'Konum arama yardımı',
    },
    salesAssistant: salesAssistantTr,
    customerHeader: customerHeaderTr,
    app: {
      name: 'ERP',
      tagline: 'Modüler Web ERP',
    },
    nav: {
      ...navigationTr,
      label: 'Ana gezinme',
      openMenu: 'Menüyü aç',
      expandGroup: "{{name}}'yi genişlet",
      collapseGroup: "{{name}}'yi daralt",
      dashboard: 'Gösterge paneli',
      partners: 'İş ortakları',
      partnerCustomers: 'Müşteriler',
      partnerProspects: 'Aday müşteriler / potansiyel müşteriler',
      partnerSuppliers: 'Tedarikçiler',
      partnerAll: 'Tüm kişiler',
      products: 'Ürünler',
      productDevelopment: 'Ürün geliştirme',
      productDevelopmentOverview: 'Genel görünüm',
      recipes: 'Reçeteler ve ürün ağaçları',
      batchScaling: 'Parti ölçekleme',
      declarations: 'Beyanlar',
      declarationCatalog: 'Beyan ana verileri',
      analysisProfiles: 'Analiz profilleri',
      analysisParameters: 'Analiz parametreleri',
      labels: 'Etiketler',
      changeControl: 'Değişiklik yönetimi',
      documents: 'Belgeler',
      dms: 'Belge arşivi',
      procurement: 'Satın alma',
      manufacturing: 'Üretim',
      productionOrders: 'Üretim emirleri',
      traceability: 'Parti izlenebilirliği',
      mrp: 'Malzeme ihtiyaç planlaması',
      purchaseOrders: 'Satın alma siparişleri',
      goodsReceipts: 'Mal kabulleri',
      vendorInvoices: 'Alış faturaları',
      analytics: 'Analizler',
      datev: 'DATEV dışa aktarımı',
      intrastat: 'Intrastat',
      settings: 'Ayarlar',
      profile: 'Profilim',
      security: 'Güvenlik',
      notifications: 'Bildirimler',
      company: 'Şirket',
      pdfDesigner: 'PDF şablonları',
      users: 'Kullanıcılar',
      roles: 'Roller ve izinler',
      securityLog: 'Güvenlik günlüğü',
      admin: 'Yönetim',
      whatsapp: 'WhatsApp',
      whatsappConfig: 'WhatsApp yapılandırması',
    },
    console: {
      label: 'Yönetim',
      breadcrumb: 'Kırıntı',
      openMenu: 'Yönetim menüsünü aç',
      backToApp: 'Ana görünüme dön',
      groups: {
        overview: 'Sistem ve genel bakış',
        access: 'Erişim ve güvenlik',
        configuration: 'Yapılandırma',
        communication: 'İletişim',
      },
      items: {
        accounting: 'DATEV hesap planı',
      },
    },
    theme: {
      label: 'Görünüm',
      light: 'Açık',
      dark: 'Koyu',
      system: 'Sistem',
    },
    language: {
      label: 'Dil',
      search: 'Dil ara',
      noResults: 'Dil bulunamadı.',
      saveError: 'Dil kaydedilemedi.',
      tr: 'Türkçe',
      fr: 'Fransızca',
      es: 'İspanyolca',
      de: 'Almanca',
      en: 'İngilizce',
    },
    dashboard: {
      title: 'Gösterge paneli',
      ...dashboardTr,
    },
    errorPage: {
      title: 'Beklenmeyen hata',
      description: 'Bu görünüm yüklenemedi.',
      reload: 'Sayfayı yeniden yükle',
    },
    systemStatus: {
      title: 'Sistem durumu',
      description: "API'nin canlı hazırlık kontrolü.",
      loading: 'Yükleme durumu…',
      error: 'Sistem durumu yüklenemedi.',
      retry: 'Tekrar dene',
      api: 'API',
      database: 'Veritabanı',
      version: 'Sürüm',
      uptime: 'Çalışma Süresi',
      state: {
        ok: 'Çalışıyor',
        degraded: 'Bozulmuş',
        up: 'Bağlandı',
        down: 'Bağlantı Kesildi',
      },
      uptimeValue: '{{minutes}} dk.',
    },
    common: {
      loading: 'Yükleniyor …',
      create: 'Oluştur',
      saving: 'Kaydediliyor…',
      save: 'Kaydet',
      confirm: 'Onayla',
      select: 'Lütfen seçin',
      error: 'Beklenmeyen bir hata oluştu.',
      cancel: 'İptal',
      back: 'Geri',
      delete: 'Sil',
      edit: 'Düzenle',
      close: 'Kapat',
      retry: 'Yeniden dene',
      previous: 'Önceki',
      next: 'Sonraki',
      none: 'Yok',
      pleaseSelect: 'Lütfen seçin',
      pagination: 'Sayfalandırma',
      paginationInfo: '{{totalPages}} · {{total}} kayıtlarının {{page}} sayfası',
      copy: 'Kopyala',
      copied: 'Kopyalandı',
      actions: 'İşlemler',
      showDetails: 'Ayrıntıları göster',
      hideDetails: 'Ayrıntıları gizle',
    },
    validation: {
      required: 'Gerekli',
      email: 'Lütfen geçerli bir e-posta adresi girin.',
    },
    errors: {
      requestFailed: 'İstek başarısız oldu',
      unexpectedTitle: 'Beklenmeyen hata',
      unexpectedMessage: 'Beklenmeyen bir hata oluştu.',
      copyHint: '(kopyalamak için tıklayın)',
      copyId: 'Kopya Kimliği',
      copied: 'Hata Kimliği {{id}} kopyalandı.',
    },
    documentPricing: {
      overrideRequired: 'Bu rol fiyatları veya mali koşulları değiştiremez.',
    },
    permissions: {
      customerPricingReadOnly:
        'Bu rol için fiyat grupları, indirimler ve erken ödeme indirimi koşulları salt okunurdur.',
      deniedTitle: 'Erişim yok',
      deniedDescription: 'Bu görünüm {{permission}} iznini gerektiriyor.',
    },
    auth: {
      title: 'Oturum aç',
      subtitle: 'Kimlik bilgilerinizle oturum açın.',
      email: 'E-posta',
      password: 'Şifre',
      tenantSlug: 'Kiracı',
      tenantSlugHint: 'Kiracının kısa adı, ör. acme.',
      submit: 'Oturum aç',
      logout: 'Oturumu kapat',
      checking: 'Oturum kontrol ediliyor…',
      invalidCredentials: 'E-posta veya şifre yanlış.',
      accountLocked: 'Hesap geçici olarak kilitlendi. Lütfen daha sonra tekrar deneyin.',
      tenantRequired: 'Bu e-posta birkaç kiracıda mevcut. Lütfen kiracıyı belirtin.',
      twoFactor: {
        title: 'İki faktörlü doğrulama',
        description: 'Kimlik doğrulayıcı uygulamanızdan altı haneli kodu girin.',
        emailDescription: '{{email}} adresine gönderilen altı haneli kodu girin.',
        useMethod: {
          TOTP: 'Kimlik doğrulama uygulamasını kullan',
          EMAIL: 'E-posta kodunu kullan',
        },
        resend: 'Kodu yeniden gönder',
        resendIn: '{{seconds}} sn sonra yeniden gönder',
        backupDescription: 'Yedek kodlarınızdan birini girin.',
        code: 'Doğrulama kodu',
        backupCode: 'Yedekleme kodu',
        submit: 'Doğrula',
        invalid: 'Kod geçersiz veya süresi dolmuş.',
        useBackupCode: 'Yedek kod kullan',
        useAuthenticator: 'Kimlik doğrulayıcı uygulamasını kullanın',
      },
    },
    customFields: {
      createTitle: 'Özel alan oluştur',
      editTitle: 'Özel alanı düzenle',
      dialogDescription:
        'Özel alanlar, müşteri verilerini kod değişikliği olmadan genişletir. Anahtar ve alan türü oluşturulduktan sonra sabitlenir.',
      key: 'Anahtar',
      keyHint: 'Teknik ad, ör. müşteriGrubu.',
      type: 'Alan türü',
      label: 'Etiket',
      labelEn: 'Etiket (İngilizce)',
      group: 'Grup',
      sortOrder: 'Sıralama düzeni',
      required: 'Gerekli',
      showInList: 'Listede göster',
      filterable: 'Filtrelenebilir',
      marketingSegmentationAllowed: 'Bülten segmentasyonu için onaylandı',
      options: 'Seçenekler',
      addOption: 'Ekle seçeneği',
      removeOption: 'Kaldır seçeneği',
      noOptions: 'Henüz tanımlanmış bir seçenek yok.',
      optionValue: 'Değer',
      optionLabel: 'Etiket',
      created: 'Özel alan oluşturuldu.',
      updated: 'Özel alan güncellendi.',
      archived: 'Özel alan arşivlendi.',
      archive: 'Arşiv',
      archiveTitle: 'Özel alanı arşivle',
      archiveDescription: '"{{name}}" alanı gizlenecek. Mevcut değerler korunur.',
      saveError: 'Özel alan kaydedilemedi.',
      loadError: 'Özel alanlar yüklenemedi.',
      filters: {
        action: 'Özel alanlar',
        title: 'Özel alanlara göre filtrele',
        description: 'Metin alanları içerik, diğer alanlar tam değer ile eşleştirilir.',
        reset: 'Sıfırla',
        clearField: '{{field}} filtresini kaldır',
      },
      weeklySchedule: {
        empty: 'Henüz zaman aralığı kaydedilmedi.',
        hint: 'Günleri ve yerel saatleri seçin. Birden fazla zaman aralığı ekleyebilirsiniz. Bitiş saati aynı gün içinde başlangıç saatinden sonra olmalıdır.',
        invalid: 'En az bir gün ve geçerli başlangıç ile bitiş saatleri girin.',
        required: 'En az bir eksiksiz zaman aralığı gereklidir.',
      },
      types: {
        WEEKLY_SCHEDULE: 'Haftanın günleri ve saatler',
        TEXT: 'Metin',
        TEXTAREA: 'Çok satırlı metin',
        NUMBER: 'Sayı',
        DATE: 'Tarih',
        CHECKBOX: 'Onay Kutusu',
        SELECT: 'Seç',
        MULTI_SELECT: 'Çoklu seçim',
      },
    },
    customers: {
      title: 'Müşteriler',
      subtitle: 'Tüm müşterilerin ana verileri, şartları ve iletişim geçmişi.',
      searchPlaceholder: 'Ad, numara, şehir, KDV numarasını arayın…',
      searchLabel: 'Müşterileri arayın',
      columnsMenu: 'Sütunlar',
      createTitle: 'Yeni müşteri',
      editTitle: 'Müşteriyi düzenle',
      formDescription: 'Gerekli alanlar işaretlenmiştir. Müşteri numarası otomatik olarak atanır.',
      created: 'Müşteri oluşturuldu.',
      updated: 'Müşteri kaydedildi.',
      saveError: 'Müşteri kaydedilemedi.',
      actions: {
        create: 'Yeni müşteri',
        export: 'Dışa Aktar',
        logCall: 'Aramayı günlüğe kaydet',
        createQuote: 'Teklif oluştur',
        backToList: 'Listeye dön',
      },
      tabs: {
        master: 'Ana veriler ve adresler',
        customFields: 'Özel alanlar',
        history: 'Geçmiş',
        documents: 'Belgeler',
        whatsapp: 'WhatsApp',
      },
      sections: {
        masterData: 'Ana veriler',
        address: 'Adres',
        tax: 'Vergi ve kimlik',
        conditions: 'Ödeme koşulları',
        customFields: 'Özel alanlar',
      },
      detail: {
        since: '{{date}} tarihinde oluşturuldu',
      },
      values: {
        days_one: '{{count}} gün',
        days_other: '{{count}} gün',
      },
      columns: {
        customerNumber: 'Sayı',
        displayName: 'Ad',
        status: 'Durum',
        industry: 'Endüstri',
        email: 'E-posta',
        phone: 'Telefon',
        city: 'Şehir',
        countryCode: 'Ülke',
        vatId: 'KDV Numarası',
        ownerName: 'Sahip',
        tags: 'Etiketler',
      },
      fields: {
        type: 'Müşteri türü',
        status: 'Durum',
        customerNumber: 'Müşteri numarası',
        customerNumberHint: 'Otomatik atama için boş bırakın.',
        industry: 'Endüstri',
        companyName: 'Şirket adı',
        firstName: 'Ad',
        lastName: 'Soyadı',
        email: 'E-posta',
        phone: 'Telefon',
        website: 'Web sitesi',
        street: 'Sokak',
        houseNumber: 'Ev numarası',
        addressLine2: 'Adres satırı 2',
        postalCode: 'Posta kodu',
        city: 'Şehir',
        region: 'Bölge',
        countryCode: 'Ülke',
        vatId: 'KDV Numarası',
        vatIdHint: 'Format doğrulandı, ör. DE123456789.',
        vatIdStatus: 'KDV Numarası durumu',
        taxNumber: 'Vergi numarası',
        taxCategory: 'Vergi kategorisi',
        datevDebtorAccount: 'DATEV borçlu hesabı',
        gln: 'GLN',
        eoriNumber: 'EORI numarası',
        currency: 'Para birimi',
        documentLanguage: 'Belge dili',
        paymentTermsDays: 'Ödeme koşulları (gün)',
        defaultDiscountPct: 'İndirim',
        cashDiscountPct: 'Nakit indirimi',
        cashDiscountDays: 'Nakit iskonto süresi (gün)',
        deliveryTerms: 'Teslimat şartları',
        creditLimit: 'Kredi limiti',
        priceGroup: 'Fiyat grubu',
        minRemainingShelfLifeDays: 'Minimum kalan raf ömrü (gün)',
        deliveryBlock: 'Teslimat bloğu',
        dunningBlock: 'İhtar bloğu',
        ownerName: 'Sahip',
        tags: 'Etiketler',
        tagsHint: 'Birden fazla değeri virgülle ayırın.',
      },
      types: {
        COMPANY: 'Şirket',
        PERSON: 'Özel kişi',
      },
      statuses: {
        ACTIVE: 'Aktif',
        PROSPECT: 'Aday müşteri',
        BLOCKED: 'Engellendi',
        INACTIVE: 'Aktif Değil',
      },
      vatIdStatuses: {
        UNCHECKED: 'İşaretlenmemiş',
        VALID: 'Geçerli',
        INVALID: 'Geçersiz',
        NOT_CHECKABLE: 'Kontrol edilemiyor',
        SERVICE_UNAVAILABLE: 'Hizmete ulaşılamıyor',
      },
      taxCategories: {
        DOMESTIC: 'Yurtiçi',
        EU_B2B: 'AB B2B',
        EU_B2C: 'AB B2C',
        THIRD_COUNTRY: 'Üçüncü ülke',
        REVERSE_CHARGE_DOMESTIC: 'Ters şarj (yurtiçi)',
        TAX_EXEMPT: 'Vergiden muaf',
      },
      industries: {
        RETAIL: 'Perakende',
        WHOLESALE: 'Toptan Satış',
        MANUFACTURING: 'İmalat',
        GASTRONOMY: 'Gastronomi',
        LOGISTICS: 'Lojistik',
        HEALTHCARE: 'Sağlık Hizmeti',
        PUBLIC_SECTOR: 'Kamu sektörü',
        CONSTRUCTION: 'İnşaat',
        AGRICULTURE: 'Tarım',
        SERVICES: 'Hizmetler',
        OTHER: 'Diğer',
      },
      documentTypes: {
        QUOTE: 'Alıntı',
        ORDER: 'Sipariş',
        DELIVERY_NOTE: 'Teslimat notu',
        INVOICE: 'Fatura',
        CREDIT_NOTE: 'Kredi notu',
        CANCELLATION: 'İptal',
      },
      documentStatuses: {
        DRAFT: 'Taslak',
        OPEN: 'Aç',
        CONFIRMED: 'Onaylandı',
        PARTIALLY_DELIVERED: 'Kısmen teslim edildi',
        DELIVERED: 'Teslim edildi',
        POSTED: 'Gönderildi',
        PAID: 'Ödendi',
        CANCELLED: 'İptal edildi',
      },
      filters: {
        status: 'Durum',
        industry: 'Endüstri',
        tags: 'Etiketler',
        vatIdStatus: 'KDV Numarası',
        reset: 'Filtreleri sıfırla',
      },
      states: {
        empty: 'Henüz müşteri yok.',
        emptyFiltered: 'Mevcut seçimle eşleşen müşteri yok.',
        error: 'Müşteri listesi yüklenemedi.',
        detailError: 'Müşteri yüklenemedi.',
      },
      export: {
        csv: "CSV'yi indir",
        xlsx: "Excel'i İndir",
        success: 'Dışa aktarma oluşturuldu.',
        error: 'Dışa aktarma başarısız oldu.',
      },
      delete: {
        title: 'Müşteriyi sil',
        description: '"{{name}}" müşterisi devre dışı bırakılacak ve gizlenecek.',
        success: 'Müşteri silindi.',
        error: 'Müşteri silinemedi.',
      },
      addresses: {
        title: 'Ek adresler',
        add: 'Adres',
        createTitle: 'Adres ekle',
        editTitle: 'Adresi düzenle',
        description: 'Teslimat ve fatura adresleri ana adresten farklı.',
        type: 'Adres türü',
        label: 'Etiket',
        recipient: 'Alıcı',
        isDefault: 'Varsayılan',
        contact: {
          title: 'Bu adresin ilgili kişisi',
          hint: 'Yalnızca bu adrese ait isteğe bağlı bilgiler. Genel bir kişi kaydı oluşturulmaz.',
          name: 'Ad',
          position: 'Görev / pozisyon',
          phone: 'Telefon',
          mobile: 'Cep telefonu',
          email: 'E-posta',
          invalidEmail: 'Lütfen geçerli bir e-posta adresi girin.',
        },
        deliveryTermsOverride: 'Farklı teslimat koşulu',
        individualDeliveryTerms: 'Özel teslimat koşulu',
        inheritedDeliveryTerms: 'Müşteri varsayılanı: {{value}}',
        deliveryTermsHint:
          'Farklı bir değer girilmezse müşteri ana verisindeki teslimat koşulu otomatik kullanılır.',
        confirmRemoveDeliveryTerms:
          'Adres türü değiştirildiğinde özel teslimat koşulu kaldırılır. Devam edilsin mi?',
        empty: 'Ek adres yok.',
        created: 'Adres kaydedildi.',
        updated: 'Adres güncellendi.',
        deleted: 'Adres silindi.',
        delete: 'Adresi sil',
        deleteTitle: 'Adresi sil',
        deleteDescription: 'Adres müşteri kaydından kaldırılacak.',
        error: 'Adres kaydedilemedi.',
        loadError: 'Adresler yüklenemedi.',
        types: {
          BILLING: 'Fatura adresi',
          SHIPPING: 'Teslimat adresi',
          OTHER: 'Diğer',
        },
      },
      contacts: {
        title: 'Kişiler',
        add: 'İletişim',
        createTitle: 'Kişi ekle',
        editTitle: 'Kişiyi düzenle',
        description: 'Fiyat teklifleri, siparişler ve çağrılar için iletişim kurulacak kişiler.',
        salutation: 'Selamlama',
        title_label: 'Başlık',
        position: 'Konum',
        department: 'Departman',
        mobile: 'Mobil',
        isPrimary: 'Birincil kişi',
        responsibilities: 'Sorumluluklar',
        responsibilitiesHint: 'Birden fazla sorumluluğu virgülle ayırın.',
        optOutMarketing: 'Pazarlama iletişimlerinden hariç tut',
        empty: 'Henüz kişi yok.',
        created: 'Kişi kaydedildi.',
        updated: 'Kişi güncellendi.',
        deleted: 'Kişi silindi.',
        delete: 'Kişiyi sil',
        deleteTitle: 'Kişiyi sil',
        deleteDescription: 'Kişi müşteri kaydından kaldırılacak.',
        error: 'Kişi kaydedilemedi.',
        loadError: 'Kişiler yüklenemedi.',
      },
      notes: {
        add: 'Not ekle',
        subject: 'Konu',
        body: 'Not',
        created: 'Not kaydedildi.',
        error: 'Not kaydedilemedi.',
      },
      calls: {
        createTitle: 'Aramayı günlüğe kaydet',
        description: 'Aramanın sonucunu, süresini ve takibini belgeleyin.',
        direction: 'Yön',
        outcome: 'Sonuç',
        subject: 'Konu',
        contact: 'İletişim',
        occurredAt: 'Zaman',
        durationSeconds: 'Süre (saniye)',
        notes: 'Çağrı notları',
        created: 'Çağrı kaydedildi.',
        error: 'Çağrı kaydedilemedi.',
        directions: {
          INBOUND: 'Gelen',
          OUTBOUND: 'Giden',
        },
        outcomes: {
          REACHED: 'Ulaşıldı',
          NOT_REACHED: 'Ulaşılmadı',
          CALLBACK: 'Geri arama kabul edildi',
          ORDER_PLACED: 'Sipariş verildi',
          COMPLAINT: 'Şikayet',
          NO_INTEREST: 'Faiz yok',
        },
      },
      quotes: {
        createTitle: 'Teklif oluştur',
        description: 'Bu müşterinin şartlarını kullanarak bir teklif taslağı oluşturur.',
        reference: 'Referans',
        validDays: 'Geçerlilik (gün)',
        submit: 'Teklif oluştur',
        created: 'Alıntı oluşturuldu.',
        error: 'Teklif oluşturulamadı.',
      },
      documents: {
        empty: 'Henüz belge yok.',
        error: 'Belgeler yüklenemedi.',
      },
      activities: {
        empty: 'Henüz etkinlik yok.',
        error: 'Geçmiş yüklenemedi.',
        types: {
          DOCUMENT: 'Belgeler',
          NOTE: 'Notlar',
          CALL: 'Aramalar',
        },
      },
      customFields: {
        title: 'Dinamik özel alanlar',
        subtitle: 'Alanlar burada yapılandırılır ve hemen kullanılabilir.',
        empty: 'Henüz tanımlanmış özel alan yok.',
        saved: 'Özel alanlar kaydedildi.',
      },
    },
    inventory: {
      expiringWidget: {
        title: 'Son kullanma tarihi uyarıları',
        description: 'Kalan raf ömrü {{days}} gün veya daha az olan partiler.',
        empty: 'Hiçbir grubun süresi yakın zamanda dolmuyor.',
        error: 'Süre sonu uyarıları yüklenemedi.',
        entry: 'Toplu {{batch}} · {{quantity}} · konum {{location}}',
        open: 'Aç',
        openBatch: 'Üründe {{batch}} grubunu açın',
        openProducts: 'Ürünlere git',
        showAll: 'Etkilenen tüm ürünleri göster',
      },
    },
    products: {
      title: 'Ürünler',
      subtitle: 'Ana veriler, fiyatlar, ambalajlar ve parti stoğu.',
      searchPlaceholder: 'Ürün numarası, adı veya GTIN …',
      searchLabel: 'Ürünleri ara',
      createTitle: 'Ürün oluştur',
      editTitle: 'Ürünü düzenle',
      formDescription: 'Tüm değerler mevcut kiracıya uygulanır.',
      created: 'Ürün oluşturuldu.',
      updated: 'Ürün kaydedildi.',
      saveError: 'Ürün kaydedilemedi.',
      columnsMenu: 'Sütunlar',
      decimals: {
        hint: 'Ondalık ayırıcı olarak nokta veya virgül kullanın: 47,45 ve 47.45 aynıdır. 47, veya 47. değeri 47 olarak kaydedilir. Binlik ayırıcı kullanmayın.',
        moneyError:
          'En fazla 4 ondalık basamaklı geçerli bir sayı girin; nokta veya virgül kullanılabilir.',
        percentError:
          '0 ile 100 arasında, en fazla 6 ondalık basamaklı bir değer girin; nokta veya virgül kullanılabilir.',
        quantityError:
          'En fazla 6 ondalık basamaklı, negatif olmayan bir sayı girin; nokta veya virgül kullanılabilir.',
      },
      texts: {
        translatedName: 'Ürün adı ({{language}})',
        translatedDescription: 'Açıklama ({{language}})',
        languageLabel: 'Ürün metinlerinin dili',
        optionalHint: 'Çeviriler isteğe bağlıdır. Çeviri yoksa Almanca metinler kullanılır.',
        validationSummary: 'Lütfen işaretli alanları kontrol edin. Girdileriniz korunur.',
        nameRequired: 'Lütfen Almanca ürün adını girin.',
        nameTooLong: 'Ürün adı en fazla 200 karakter içerebilir.',
        descriptionTooLong: 'Açıklama en fazla 4000 karakter içerebilir.',
      },
      tabs: {
        master: 'Ana veriler ve fiyatlar',
        priceTiers: 'Fiyat katmanları',
        specifications: 'Spesifikasyonlar',
        packagings: 'Ambalajlar',
        batches: 'Gruplar ve son kullanma tarihleri',
        movements: 'Hisse senedi geçmişi',
      },
      detail: {
        stockSummary: 'Stok {{stock}} {{unit}} · mevcut {{available}} {{unit}}',
      },
      badges: {
        batchManaged: 'Toplu yönetim',
        belowMinStock: 'Minimum stokun altında',
      },
      actions: {
        create: 'Ürün oluştur',
        export: 'Dışa Aktar',
        bulkPrice_one: 'Fiyatları güncelle ({{count}})',
        bulkPrice_other: 'Fiyatları güncelle ({{count}})',
        adjustStock: 'Stoku ayarla',
        backToList: 'Listeye dön',
      },
      export: {
        csv: "CSV'yi indir",
        xlsx: "Excel'i İndir",
        success: 'Dışa aktarma oluşturuldu.',
        error: 'Dışa aktarma başarısız oldu.',
      },
      states: {
        empty: 'Henüz ürün yok.',
        emptyFiltered: 'Mevcut filtrelerle eşleşen ürün yok.',
        error: 'Ürünler yüklenemedi.',
        detailError: 'Ürün yüklenemedi.',
      },
      selection: {
        toggleAll: 'Bu sayfadaki tüm ürünleri seç',
        toggleRow: "{{name}}'yi seçin",
      },
      columns: {
        icon: 'Tür',
        articleNumber: 'Ürün no.',
        name: 'Ad',
        productGroup: 'Ürün grubu',
        stock: 'Hisse Senedi',
        available: 'Mevcut',
        listPrice: 'Liste fiyatı',
        purchasePrice: 'Maliyet',
        batches: 'Gruplar',
        status: 'Durum',
        tags: 'Etiketler',
      },
      batchBadge: {
        count_one: '{{count}} toplu iş',
        count_other: '{{count}} grupları',
        expiring_one: '{{count}} son kullanma uyarısı',
        expiring_other: '{{count}} süre sonu uyarıları',
      },
      filters: {
        criticalStock: 'Kritik hisse senedi',
        expiring: 'Süre sonu uyarıları (< {{days}} gün)',
        activeOnly: 'Yalnızca aktif ürünler',
        status: 'Durum',
        type: 'Ürün türü',
        productGroup: 'Ürün grubu',
        batchManaged: 'Toplu izleme',
        batchManagedOnly: 'Yalnızca toplu yönetilen',
        batchManagedNone: 'Toplu izleme olmadan',
        reset: 'Filtreleri sıfırla',
      },
      sections: {
        base: 'Ana veriler',
        prices: 'Fiyatlar ve planlama',
        logistics: 'Lojistik ve gümrük',
        batches: 'Gruplar ve son kullanma tarihleri',
        customFields: 'Özel alanlar',
      },
      fields: {
        articleNumber: 'Ürün numarası',
        articleNumberHint: 'Aralıktan bir sonraki sayıyı çizmek için boş bırakın.',
        name: 'Ad',
        nameEn: 'Ad (EN)',
        description: 'Açıklama',
        type: 'Ürün türü',
        status: 'Durum',
        ean: 'GTIN/EAN',
        manufacturerNumber: 'Üretici numarası',
        productGroup: 'Ürün grubu',
        baseUnit: 'Ana ünite',
        taxRateType: 'Vergi oranı',
        taxRatePct: 'Vergi oranı (%)',
        currency: 'Para birimi',
        listPrice: 'Satış fiyatı',
        purchasePrice: 'Satın alma fiyatı',
        minMarginPct: 'Minimum marj (%)',
        marginHint: 'Mevcut marj: {{value}}',
        weightNetKg: 'Net ağırlık (kg)',
        weightGrossKg: 'Brüt ağırlık (kg)',
        commodityCode: 'Ürün kodu',
        commodityCodeHint: '8, 10 veya 11 haneli gümrük tarife numarası.',
        countryOfOrigin: 'Menşe ülke',
        minStock: 'Minimum stok',
        reorderPoint: 'Yeniden sıralama noktası',
        targetStock: 'Hedef stok',
        leadTimeDays: 'Teslim süresi (gün)',
        isBatchManaged: 'Toplu yönetim',
        isShelfLifeManaged: 'Raf ömrü yönetildi',
        shelfLifeDays: 'Raf ömrü (gün)',
        shelfLifeDaysHint:
          'Yeni partilerin son kullanma tarihini önceden doldurmak için kullanılır.',
        minRemainingShelfLifeDays: 'Minimum kalan raf ömrü (gün)',
        pickingStrategy: 'Seçim stratejisi',
        tags: 'Etiketler',
        tagsHint: 'Birden fazla değeri virgülle ayırın.',
      },
      statuses: {
        ARCHIVED: 'Arşivlendi',
        ACTIVE: 'Aktif',
        PHASE_OUT: 'Aşamalı olarak kullanımdan kaldırılıyor',
        DISCONTINUED: 'Üretimi durduruldu',
        BLOCKED: 'Engellendi',
      },
      types: {
        STOCK: 'Stok öğesi',
        NON_STOCK: 'Stokta olmayan ürün',
        SERVICE: 'Hizmet',
        SET: 'Malzeme listesi',
        DEPOSIT: 'Para Yatırma',
      },
      taxRateTypes: {
        STANDARD: 'Standart ücret',
        REDUCED: 'İndirimli oran',
        ZERO: 'Sıfır oran',
      },
      pickingStrategies: {
        FEFO: 'FEFO (ilk süresi dolmuş, ilk çıkar)',
        FIFO: 'FIFO (ilk giren ilk çıkar)',
        MANUAL: 'Manuel seçim',
      },
      images: {
        title: 'Ürün görselleri',
        gallery: 'Görsel galerisi',
        empty: 'Bu ürüne henüz görsel eklenmedi.',
        loadError: 'Ürün görselleri yüklenemedi.',
        drop: 'Görselleri buraya bırakın veya dosya seçin',
        detected: '{{count}} dosya algılandı',
        remaining: '{{count}} görsel yeri kaldı · JPEG, PNG, WebP veya AVIF',
        choose: 'Dosya seç',
        camera: 'Kamerayı kullan',
        invalidSelection: 'En az bir dosya geçersiz veya azami görsel sayısı aşılacak.',
        removePending: '{{name}} dosyasını seçimden kaldır',
        partialUploadError:
          '{{count}} görsel yüklenemedi. Ürün kaydedildi; yalnızca bu dosyaları yeniden deneyin.',
        limits: 'JPEG, PNG, WebP veya AVIF · azami 20 MB · en fazla {{count}} görsel',
        count: '{{max}} görselden {{current}} tanesi',
        progress: 'Yükleme: %{{progress}}',
        uploadStates: {
          PENDING: 'Bekliyor',
          UPLOADING: 'Yükleniyor: %{{progress}}',
          SUCCESS: 'Yüklendi',
          FAILED: 'Başarısız — kaydederken yeniden deneyin',
        },
        uploaded: '{{count}} görsel yüklendi.',
        uploadError: 'Görseller yüklenemedi.',
        emptyFile: 'Dosya boş.',
        fileTooLarge: 'Dosya 20 MB sınırını aşıyor.',
        unsupportedFormat: 'Yalnızca JPEG, PNG, WebP ve AVIF desteklenir.',
        tooMany: 'Bir üründe en fazla {{count}} görsel olabilir.',
        selection: 'Seçim',
        select: '{{title}} görselini seç',
        primary: 'Ana görsel',
        makePrimary: 'Ana görsel yap',
        primarySet: 'Ana görsel değiştirildi.',
        fullscreen: 'Tam ekran',
        original: 'Orijinali görüntüle',
        replace: 'Görseli değiştir',
        replaced: 'Görsel değiştirildi.',
        deleteTitle: 'Ürün görseli silinsin mi?',
        deleteDescription: '“{{name}}” ve tüm görsel varyantları kalıcı olarak silinir.',
        deleted: 'Görsel silindi.',
        deleteError: 'Görsel silinemedi.',
        sorted: 'Görsel sırası kaydedildi.',
        sortError: 'Görsel sırası kaydedilemedi.',
        editTitle: 'Görsel ayrıntılarını düzenle',
        editDescription: 'Başlık ve alternatif metin erişilebilir sunumu destekler.',
        imageTitle: 'Görsel başlığı',
        altText: 'Alternatif metin',
        altHint: 'Görseldeki içeriği kısa ve nesnel biçimde açıklayın.',
        updated: 'Görsel ayrıntıları kaydedildi.',
        updateError: 'Görsel güncellenemedi.',
        retrySuccess: 'Görsel varyantları yeniden oluşturuldu.',
      },
      batchStatuses: {
        FREE: 'Ücretsiz',
        QUARANTINE: 'Karantina',
        BLOCKED: 'Engellendi',
        EXPIRED: 'Süresi Doldu',
        DEPLETED: 'Tükendi',
      },
      movementTypes: {
        GOODS_RECEIPT: 'Mal kabul',
        GOODS_ISSUE: 'Mal çıkışı',
        TRANSFER_IN: 'Aktarma',
        TRANSFER_OUT: 'Dışarı aktar',
        ADJUSTMENT: 'Ayarlama',
        INVENTORY_COUNT: 'Envanter sayımı',
        SCRAP: 'Hurda',
        RETURN_IN: 'Müşteri iadesi',
        RETURN_OUT: 'Tedarikçi iadesi',
      },
      referenceTypes: {
        MANUAL: 'Kılavuz',
        ORDER: 'Sipariş',
        DELIVERY_NOTE: 'Teslimat notu',
        INVOICE: 'Fatura',
        PURCHASE_ORDER: 'Satınalma siparişi',
        INVENTORY: 'Envanter',
        PRODUCTION: 'Üretim',
      },
      units: {
        PCE: 'adet',
        KGM: 'kg',
        GRM: 'g',
        LTR: 'l',
        MLT: 'ml',
        MTR: 'm',
        MTQ: 'm³',
        MTK: 'm²',
        PA: 'paketi',
      },
      packagingUnits: {
        BX: 'Kutu',
        CT: 'Karton',
        PF: 'Palet',
        PK: 'Paketi',
        TU: 'Tepsi',
        BG: 'Çanta',
        CS: 'Vaka',
      },
      priceTiers: {
        add: 'Seviye ekle',
        remove: 'Seviyeyi kaldır',
        empty: 'Henüz tanımlanmış fiyat kademesi yok.',
        saved: 'Fiyat kademeleri kaydedildi.',
        saveError: 'Fiyat katmanları kaydedilemedi.',
        calculate: 'İndirimi uygula',
        calculatorHint: 'İndirim liste fiyatına uygulanır.',
        columns: {
          priceGroup: 'Fiyat grubu',
          minQuantity: 'Miktardan',
          unitPrice: 'Birim fiyatı',
          discountPct: 'İndirim (%)',
          margin: 'Marj',
          validFrom: 'tarihinden itibaren geçerli',
          validTo: 'Geçerlilik tarihi:',
        },
      },
      packagings: {
        add: 'Paketleme ekle',
        remove: 'Ambalajı çıkarın',
        empty: 'Henüz tanımlanmış bir ambalaj yok.',
        description: 'Dönüşüm faktörü ambalaj başına {{unit}} cinsinden miktarı tanımlar.',
        saved: 'Paketlemeler kaydedildi.',
        saveError: 'Paketler kaydedilemedi.',
        fields: {
          code: 'Kodu',
          name: 'Ad',
          unitCode: 'Ambalaj türü',
          factor: 'Dönüşüm faktörü',
          factorHint: 'Paket başına {{unit}} cinsinden miktar.',
          ean: "Paketleme GTIN'si",
          weightGrossKg: 'Brüt ağırlık (kg)',
          lengthMm: 'Uzunluk (mm)',
          widthMm: 'Genişlik (mm)',
          heightMm: 'Yükseklik (mm)',
          minOrderQuantity: 'Minimum sipariş miktarı',
          orderStepQuantity: 'Sipariş artışı',
          isSalesDefault: 'Satış temerrüdü',
          isPurchaseDefault: 'Satın alma varsayılanı',
        },
      },
      batches: {
        create: 'Toplu ekle',
        empty: 'Henüz parti yok.',
        error: 'Gruplar yüklenemedi.',
        notManaged: 'Bu ürün toplu olarak yönetilmiyor.',
        includeDepleted: 'Tükenmiş partileri göster',
        totalRemaining: 'Toplam stok {{value}} {{unit}}',
        daysLeft_one: '{{count}} gün kaldı',
        daysLeft_other: '{{count}} gün kaldı',
        block: 'Blok',
        release: 'Yayınla',
        blocked: '{{batch}} grubu engellendi.',
        released: '{{batch}} grubu yayınlandı.',
        blockTitle: 'Toplu bloğu engelle',
        blockDescription: '{{batch}} grubu sorunlar nedeniyle engellenecek.',
        blockReason: 'Sebep',
        releaseReason: 'Denetimden sonra serbest bırakıldı',
        updateError: 'Grup güncellenemedi.',
        customFieldsEditTitle: 'Parti özel alanlarını düzenle',
        customFieldsEditDescription: '{{batch}} partisi için ek bilgiler.',
        customFieldsSaved: 'Parti özel alanları kaydedildi.',
        levels: {
          EXPIRED: 'Süresi Doldu',
          CRITICAL: 'Kritik',
          WARNING: 'Uyarı',
          OK: 'Kritik değil',
        },
        columns: {
          batchNumber: 'Toplu',
          bestBeforeDate: 'Önceki en iyisi',
          remainingShelfLife: 'Kalan raf ömrü',
          remaining: 'Kalan miktar',
          storageLocation: 'Depolama konumu',
          status: 'Durum',
          actions: 'İşlemler',
        },
      },
      batchDialog: {
        title: 'Toplu ekle',
        description: '{{name}} için mal girişi.',
        submit: 'Toplu ekle',
        created: 'Toplu {{batch}} eklendi.',
        error: 'Grup oluşturulamadı.',
        fields: {
          batchNumber: 'Parti numarası',
          quantity: 'Miktar ({{unit}})',
          productionDate: 'Üretim tarihi',
          bestBeforeDate: 'Önceki en iyi tarih',
          bestBeforeHint: '{{days}} günlük raf ömründen önerildi.',
          storageLocation: 'Depolama konumu',
          warehouseCode: 'Depo',
          supplierBatchNumber: 'Tedarikçi grubu',
          certificateRef: 'Sertifika',
          countryOfOrigin: 'Menşe ülke',
          unitCost: 'Birim maliyeti',
          referenceType: 'Referans türü',
          notes: 'Notlar',
        },
      },
      adjustment: {
        title: 'Stok ayarlaması',
        description: '{{name}} · mevcut stok {{stock}}',
        modeLabel: 'Gönderme türü',
        modes: {
          DELTA: 'Ayar miktarı',
          COUNT: 'Sayılan stok',
        },
        submit: 'Gönderi',
        success: 'Stok ayarlandı.',
        newStock: 'Yeni hisse senedi: {{value}}',
        error: 'Gönderim başarısız oldu.',
        fields: {
          quantity: 'Ayar miktarı',
          quantityHint: 'Pozitif değerler stok ekler, negatif değerler ise kaldırır.',
          countedQuantity: 'Sayılan stok',
          countedQuantityHint: 'Kitap stoğundaki fark otomatik olarak yayınlanır.',
          batch: 'Toplu',
          warehouseCode: 'Depo',
          reason: 'Sebep',
          reasonHint: 'Zorunlu, en az {{min}} karakter (denetim kanıtı).',
        },
      },
      movements: {
        description: 'Tüm stok hareketleri denetime uygun düzende.',
        empty: 'Henüz hiçbir hareket gönderilmedi.',
        error: 'Stok geçmişi yüklenemedi.',
        filterType: 'Hareket türü',
        balanceAfter: 'Şu tarihten sonraki bakiye: {{value}}',
        entry: '{{date}} · {{user}} · {{reference}}',
      },
      bulkPrice: {
        title: 'Fiyatları güncelle',
        description: 'Değişiklik {{count}} seçilen ürünlere uygulandı.',
        submit: 'Fiyatları güncelle',
        success: '{{updated}} ürünleri güncellendi, {{skipped}} atlandı.',
        error: 'Fiyat güncellemesi başarısız oldu.',
        targets: {
          LIST_PRICE: 'Satış fiyatı',
          PURCHASE_PRICE: 'Satın alma fiyatı',
        },
        modes: {
          PERCENT: 'Yüzde olarak değişim',
          ABSOLUTE: 'Tutar ekle',
          SET: 'Sabit fiyatı ayarla',
        },
        valueLabels: {
          PERCENT: 'Yüzde olarak değişim',
          ABSOLUTE: 'Tutar olarak değiştir',
          SET: 'Yeni fiyat',
        },
        fields: {
          target: 'Fiyat alanı',
          mode: 'Hesaplama',
          roundTo: 'Ondalık basamaklar',
          reason: 'Sebep',
          reasonHint: 'Denetim günlüğünde saklanır.',
        },
      },
    },
    documents: {
      packaging: {
        baseUnitPriceColumn: 'Adet / temel birim fiyatı',
        baseUnitPriceLabel: '{{unit}} başına fiyat',
        baseUnitPriceInvalid:
          'En fazla dört ondalık basamaklı geçerli bir fiyat girin. Hesaplanan ambalaj fiyatı da izin verilen aralıkta olmalıdır.',
        baseUnitPrice: '{{unit}} başına fiyat: {{price}}',
        label: 'Birim / ambalaj',
        conversion: '{{quantity}} {{packaging}} = {{baseQuantity}} {{baseUnit}}',
        historic: 'kayıtlı',
        loading: 'Ambalajlar yükleniyor …',
        loadError: 'Ambalajlar yüklenemedi.',
        pricing: 'Fiyat hesaplanıyor …',
        priceError: 'Fiyat doğrulanmadı. Miktarı ve ambalajı kontrol edip yeniden deneyin.',
        saveBlocked: 'Kaydetmeden önce ambalajları yükleyin ve fiyat hesaplamasını tamamlayın.',
        invalid: 'Geçerli bir miktar girin.',
        minimum: 'Seçili birimde asgari miktar {{value}} olmalıdır.',
        step: 'Miktar, seçili birimde {{value}} değerinin katı olmalıdır.',
      },
      legacyCustomFieldsNotice:
        'Bu eski belgenin özel alanlarının geçmiş tanımları mevcut değil. Alanlar yeniden yorumlanmaz. Lütfen özgün çıktıyı kullanın.',
      title: 'Belgeler',
      subtitle: 'Belge zinciri boyunca teklifler, siparişler, irsaliyeler ve faturalar.',
      tabs: {
        all: 'Hepsi',
      },
      types: {
        QUOTE: 'Teklif',
        ORDER: 'Sipariş',
        DELIVERY_NOTE: 'Teslimat notu',
        INVOICE: 'Fatura',
        CANCELLATION: 'İptal faturası',
        CREDIT_NOTE: 'Kredi notu',
        PURCHASE_ORDER: 'Satınalma siparişi',
      },
      statuses: {
        DRAFT: 'Taslak',
        SENT: 'Gönderildi',
        ACCEPTED: 'Kabul edildi',
        REJECTED: 'Reddedildi',
        CONFIRMED: 'Onaylandı',
        IN_PROGRESS: 'Devam ediyor',
        PARTIALLY_PROCESSED: 'Kısmen işlendi',
        SHIPPED: 'Gönderildi',
        COMPLETED: 'Tamamlandı',
        POSTED: 'Gönderildi',
        CANCELLED: 'İptal edildi',
      },
      paymentStatuses: {
        OPEN: 'Aç',
        PARTIALLY_PAID: 'Kısmen ödendi',
        PAID: 'Ödendi',
        OVERDUE: 'Vadesi geçmiş',
        WRITTEN_OFF: 'Yazıldı',
      },
      taxStrategies: {
        REGULAR: 'Standart vergilendirme',
        REVERSE_CHARGE: 'Ters şarj',
        INTRA_COMMUNITY: 'Topluluk içi tedarik',
        EXPORT_NON_EU: 'İhracat (AB dışı)',
      },
      taxDetermination: {
        title: 'Açıklanabilir vergi belirleme',
        loading: 'Vergi önerisi kontrol ediliyor…',
        unavailable: 'Vergi önerisi şu anda kullanılamıyor',
        selectCustomer: 'Bir öneri almak için müşteri, teslimat şekli ve kalemleri seçin.',
        suggestion: 'Öneri',
        applySuggestion: 'Öneriyi uygula',
        reasonsTitle: 'Karar nedenleri',
        actionsTitle: 'Bekleyen kontroller ve kanıtlar',
        noActions: 'Bekleyen bir kontrol bulunmadı.',
        overrideReason: 'Farklı kararın gerekçesi',
        overridePlaceholder: 'İncelenen ticari gerekçeyi kaydedin (en az 10 karakter)',
        overrideForbidden: 'Yalnızca yetkili roller öneriden sapabilir.',
        disclaimer:
          'Bu öneri belge incelemesini destekler; vergi veya hukuk danışmanlığı değildir. Zincir ve üçgen işlemler gibi özel durumlar uzman incelemesi gerektirir.',
        deliveryMode: 'Teslimat şekli',
        deliveryModes: {
          SHIPMENT: 'Sevkiyat',
          PICKUP: 'Teslim alma',
          UNKNOWN: 'Henüz kararlaştırılmadı',
        },
        assessments: {
          ELIGIBLE: 'Koşullar tespit edildi',
          NOT_ELIGIBLE: 'Koşullar karşılanmadı',
          REVIEW_REQUIRED: 'İnceleme gerekli',
        },
        reasons: {
          CROSS_BORDER_EU_DESTINATION: 'Varış yeri başka bir AB üyesi devlettedir.',
          DOMESTIC_DESTINATION: 'Varış yeri satıcının ülkesindedir.',
          DESTINATION_NOT_EU: 'Varış yeri AB dışındadır.',
          DESTINATION_MISSING: 'Gerçek varış yeri henüz doğrulanmadı.',
          SELLER_NOT_EU: 'Satıcı belge tarihinde bir AB üyesi devlette değildi.',
          CUSTOMER_IS_COMPANY: 'Müşteri şirket olarak kayıtlıdır.',
          CUSTOMER_NOT_COMPANY: 'Müşteri şirket olarak kayıtlı değildir.',
          CUSTOMER_CONFIGURED_EU_B2B: 'Müşteri AB B2B olarak yapılandırılmıştır.',
          CUSTOMER_NOT_CONFIGURED_EU_B2B: 'Müşterinin vergi kategorisi AB B2B değildir.',
          VAT_ID_VALID_AND_CURRENT: 'Güncel KDV numarası için geçerli VIES kanıtı vardır.',
          VAT_ID_MISSING: 'Müşterinin KDV numarası yoktur.',
          VAT_ID_INVALID: 'Son KDV numarası kontrolü geçerli değildi.',
          VAT_ID_COUNTRY_MISMATCH: 'KDV numarası öneki varış yeriyle eşleşmiyor.',
          VAT_VALIDATION_MISSING: 'VIES kontrolü bulunmuyor.',
          VAT_VALIDATION_STALE: 'VIES kanıtı eskidir veya eski bir eşleme kullanır.',
          VAT_VALIDATION_UNAVAILABLE: 'VIES kullanılamıyordu; bu durum geçerli kanıt sayılmaz.',
          VAT_ID_CHANGED_SINCE_DOCUMENT_SNAPSHOT:
            'KDV numarası önceki belge anlık görüntüsünden sonra değişti.',
          BILLING_AND_DESTINATION_DIFFER: 'Fatura ülkesi ile gerçek varış ülkesi farklıdır.',
          GOODS_SUPPLY: 'Kalemler mal teslimi olarak tanımlandı.',
          SERVICE_SUPPLY_REVIEW: 'Hizmetler ayrı bir ifa yeri ve vergi incelemesi gerektirir.',
          MIXED_SUPPLY_REVIEW: 'Mal ve hizmetler birlikte bulunduğundan ayrı inceleme gereklidir.',
          SUPPLY_TYPE_UNKNOWN: 'Teslimat türü henüz net değildir.',
          PICKUP_REVIEW: 'Teslim alma durumunda sınır ötesi hareket için ayrı kanıt gerekir.',
          DELIVERY_MODE_UNKNOWN: 'Teslimat şekli henüz kararlaştırılmadı.',
          TRANSPORT_EVIDENCE_AVAILABLE: 'Bağlı sevkiyat veya gümrük kanıtı mevcuttur.',
          TRANSPORT_EVIDENCE_REQUIRED: 'Muafiyet için sevkiyat kanıtı hâlâ gereklidir.',
          EXISTING_EXPORT_CONFIGURATION: 'Müşterinin ihracat yapılandırması dikkate alındı.',
          EXISTING_REVERSE_CHARGE_CONFIGURATION:
            'Mevcut tersine vergilendirme yapılandırması dikkate alındı.',
          MASTER_FACTS_INCOMPLETE:
            'Vergi değerlendirmesi için güncel ana veri veya adres bilgileri eksik.',
          SPECIAL_CASE_REVIEW: 'Bu durum otomatik değildir ve uzman incelemesi gerektirir.',
        },
        actions: {
          VERIFY_VAT_ID: 'Güncel bir VIES KDV numarası kontrolü yapın.',
          CONFIRM_DESTINATION: 'Gerçek varış yerini doğrulayın.',
          COLLECT_TRANSPORT_EVIDENCE:
            'Bir irsaliye veya güvenilir sevkiyat/gümrük kanıtı bağlayın.',
          REVIEW_SUPPLY_TYPE: 'Mal veya hizmet sınıflandırmasını inceleyin.',
          REVIEW_PICKUP_OR_SPECIAL_CASE: 'Teslim alma veya özel durumu bir uzmana inceletin.',
          COMPLETE_MASTER_FACTS: 'Belirtilen ana veri veya adres bilgilerini inceleyip tamamlayın.',
          PROVIDE_OVERRIDE_REASON: 'Farklı vergi kararını açıklayın.',
        },
      },
      paymentMethods: {
        INVOICE: 'Fatura (hesaba ödeme)',
        PREPAYMENT: 'Ön ödeme',
        CASH: 'Nakit',
      },
      languages: {
        tr: 'Türkçe',
        es: 'İspanyolca',
        de: 'Almanca',
        en: 'İngilizce',
        fr: 'Fransızca',
      },
      languageFallback:
        'Bu dil için yerleşik şablon yok. Kiracıya özel şablon bulunmazsa Almanca kullanılır.',
      columns: {
        number: 'Belge no.',
        type: 'Türü',
        customer: 'Müşteri',
        documentDate: 'Belge tarihi',
        dueDate: 'Vadesi gelmiş',
        status: 'Durum',
        grossTotal: 'Brüt',
      },
      filters: {
        search: 'Belgeleri arayın',
        searchPlaceholder: 'Belge numarası, referans veya müşteri…',
        status: 'Durum',
        allStatuses: 'Tüm durumlar',
        dateFrom: 'Belge tarihi:',
        dateTo: 'Belge tarihi:',
        payment: {
          ALL: 'Hepsi',
          OPEN: 'Aç',
          OVERDUE: 'Vadesi geçmiş',
          PAID: 'Ödendi',
        },
      },
      actions: {
        create: 'Yeni belge',
        lock: 'Belgeyi yayınla',
        sendEmail: 'E-posta ile gönder',
        convertTo: {
          QUOTE: 'Teklife dönüştür',
          ORDER: 'Siparişe dönüştür',
          DELIVERY_NOTE: 'Teslimat notu oluştur',
          INVOICE: 'Fatura oluştur',
          CANCELLATION: 'İptal',
          CREDIT_NOTE: 'Kredi notu oluştur',
          PURCHASE_ORDER: 'Satınalma siparişi oluştur',
        },
      },
      states: {
        empty: 'Henüz belge yok.',
        pagination: '{{totalPages}} · {{total}} belgelerinin {{page}} sayfası',
      },
      editor: {
        back: 'Listeye dön',
        newTitle: 'Yeni belge',
        newSubtitle: 'Bir müşteri seçin, belge kalemlerini ekleyin ve kaydedin.',
        type: 'Belge türü',
        headSection: 'Belge başlığı',
        itemsSection: 'Belge kalemleri',
        textsSection: 'Metinler',
        customFieldsSection: 'Özel alanlar',
        customFieldsInvalid: '{{count}} alanını kontrol edin',
        customFieldsInvalid_other: '{{count}} alanlarını kontrol edin',
        addCustomField: 'Ek alan ekle',
        addCustomFieldHint: 'Bir belge alanı arayın veya listeyi kategoriye göre filtreleyin.',
        removeCustomField: '{{field}} alanını belgeden kaldır',
        searchCustomFields: 'Ek alanlarda ara…',
        customFieldCategory: 'Ek alan kategorisi',
        allCustomFieldCategories: 'Tüm kategoriler',
        uncategorizedFields: 'Kategorisiz',
        noDocumentCustomFields: 'Bu belge türü için yapılandırılmış özel alan yok.',
        noCustomFieldsSelected: 'Henüz isteğe bağlı ek alan seçilmedi.',
        noCustomFieldsAvailable: 'Eşleşen başka ek alan bulunamadı.',
        itemCustomFieldColumns: 'Ek alan sütunları',
        customFieldsToast: 'Özel alan hatası: {{field}} — {{reason}} [ID: {{id}}]',
        customFieldsMore: 'Bir alan daha geçersiz.',
        customFieldsMore_other: '{{count}} daha fazla alan da geçersiz.',
        customerPlaceholder: 'Müşteriyi ara…',
        noCustomers: 'Müşteri bulunamadı.',
        incomplete: 'Lütfen müşteriyi, alıcıyı ve en az bir satır öğesini belirtin.',
        created: 'Belge oluşturuldu.',
        saved: 'Belge kaydedildi.',
        partialQuantities: 'Kısmi miktarları seç',
        conversionQuantitiesHint:
          'Seçim yapılmazsa kalan tüm miktarlar aktarılır. Kısmi aktarımda 0 veya boş alan satırı atlar. Mevcut aktarımlar belge oluşturulurken kontrol edilir.',
        conversionQuantityInvalid: 'En az bir geçerli pozitif miktar girin.',
        converted: 'Takip belgesi oluşturuldu.',
        convertFailed: "{{type}}'ye dönüştürme başarısız oldu",
        locked: 'Belge yayınlandı.',
        customerLockedTitle: '🚨 Müşteri satışlara kilitlendi',
        customerLockedReason: 'Sebep: {{reason}}',
        customerLockedHint:
          'Bu müşteri için hiçbir belge oluşturulamaz. Lütfen muhasebeyle iletişime geçin.',
        customerLockedOverride: 'İbra yalnızca ödeme yöntemiyle ön ödeme veya nakit ile mümkündür.',
        customerLockedSwitchToPrepayment: 'Ön ödemeye geç',
      },
      deliveryTerms: {
        replaceManualConfirmation:
          'Elle girilen teslimat koşulu yeni adres varsayılanıyla değiştirilsin mi?',
        reset: 'Varsayılana dön',
        sources: {
          CUSTOMER_DEFAULT: 'Kaynak: müşteri varsayılanı',
          SHIPPING_ADDRESS: 'Kaynak: teslimat adresi',
          MANUAL: 'Kaynak: elle değiştirildi',
          NONE: 'Teslimat koşulu yok',
        },
      },
      quoteValidity: {
        automaticHint:
          'Otomatik: belge tarihinden itibaren {{days}} gün. Tarihi değiştirebilir veya silebilirsiniz.',
        manualHint: 'Teklifin geçerlilik tarihi. Gerektiğinde değiştirin veya boş bırakın.',
        loading: 'Varsayılan geçerlilik yükleniyor …',
        loadError:
          'Varsayılan geçerlilik yüklenemedi. Yeniden deneyin veya tarihi elle belirleyin.',
      },
      fields: {
        customer: 'Müşteri',
        recipient: 'Alıcı',
        documentDate: 'Belge tarihi',
        validUntil: 'Geçerlilik tarihi',
        reference: 'Referansınız',
        language: 'Belge dili',
        currency: 'Para birimi',
        taxStrategy: 'Vergi tespiti',
        paymentMethod: 'Ödeme yöntemi',
        paymentTermsDays: 'Ödeme koşulları (gün)',
        cashDiscountPct: 'Nakit indirimi %',
        cashDiscountDays: 'Nakit indirimi günleri',
        discountPct: 'Genel indirim yüzdesi',
        shippingAmount: 'Gönderim',
        shippingAddress: 'Teslimat adresi',
        noShippingAddress: 'Teslimat adresi yok',
        searchShippingAddress: 'Etiket, alıcı veya şehir ara',
        noMatchingShippingAddress: 'Eşleşen teslimat adresi bulunamadı.',
        unnamedShippingAddress: 'Bilgisi olmayan teslimat adresi',
        deliveryTerms: 'Teslimat koşulu',
        headerText: 'Başlık metni',
        footerText: 'Altbilgi metni',
        internalNote: 'Dahili not',
      },
      items: {
        position: 'Öğe',
        article: 'Ürün',
        articlePlaceholder: 'Ürün ara…',
        noArticles: 'Hiçbir makale bulunamadı.',
        text: 'Serbest metin',
        quantity: 'Adet',
        unit: 'Birim',
        unitPrice: 'Birim fiyatı',
        discount: "İndirim %'si",
        taxRate: "KDV %'si",
        lineNet: 'Net',
        remove: 'Satırı kaldır',
        addArticle: 'Ürün satırı',
        addText: 'Metin satırı',
        batch: 'Toplu',
        stock: 'Hisse Senedi',
        selectBatch: 'Grup seç',
      },
      totals: {
        title: 'Hesaplama',
        itemsNet: 'Kalemler net toplamı',
        discount: 'Genel indirim {{pct}}',
        shipping: 'Gönderim',
        net: 'Net tutar',
        tax: '{{base}} üzerindeki KDV {{pct}}',
        gross: 'Toplam tutar',
        cashDiscount:
          '{{days}} gün içinde ödeme yapın: {{pct}} nakit indirimi ({{amount}}) – ödenecek {{payable}}.',
      },
      batchPicker: {
        title: 'Toplu seçim',
        description: 'Seçilen toplama stratejisine dayalı olarak "{{product}}" teklifi.',
        strategy: 'Strateji',
        bestBefore: 'Önceki en iyisi',
        apply: 'Uygula',
        empty: 'Kullanılabilir toplu iş bulunamadı.',
        shortfall: '{{quantity}} birimlerinde eksiklik.',
        levels: {
          EXPIRED: 'Süresi Doldu',
          CRITICAL: 'Kritik',
          WARNING: 'Uyarı',
          OK: 'Kritik değil',
          UNKNOWN: 'Son kullanma tarihi yok',
        },
      },
      preview: {
        title: 'PDF önizlemesi',
        refresh: 'Önizlemeyi yenile',
        download: "PDF'yi İndir",
        toggle: 'Önizlemeyi değiştir',
        stale: 'Önizleme son kaydedilen durumu gösterir.',
      },
      email: {
        title: 'Belgeyi gönder',
        description: '{{number}} belgesini PDF ekiyle gönderin.',
        to: 'Alıcı',
        subject: 'Konu',
        body: 'Mesaj',
        submit: 'Bağlayıcı olarak gönder',
        success: 'Belge gönderildi.',
        failed: 'Gönderim başarısız oldu.',
      },
      delete: {
        title: 'Belgeyi sil',
        description: '{{number}} taslağı silinecek. Bu eylem geri alınamaz.',
        success: 'Belge silindi.',
      },
    },
    users: {
      title: 'Kullanıcı yönetimi',
      subtitle: 'Bu kiracı içindeki hesaplar, roller ve durum.',
      create: 'Kullanıcı ekle',
      searchPlaceholder: 'Adı veya e-postayı arayın',
      error: 'Kullanıcılar yüklenemedi.',
      columns: {
        name: 'Ad',
        email: 'E-posta',
        role: 'Rol',
        status: 'Durum',
        twoFactor: '2FA',
        lastLogin: 'Son giriş',
      },
      status: {
        active: 'Aktif',
        inactive: 'Devre Dışı',
        locked: 'Kilitli',
      },
      twoFactor: {
        on: 'Etkin',
        off: 'Devre Dışı',
      },
      filters: {
        role: 'Role göre filtrele',
        allRoles: 'Tüm roller',
      },
      empty: {
        title: 'Kullanıcı bulunamadı',
        description: 'Aramayı ayarlayın veya yeni bir hesap oluşturun.',
      },
      actions: {
        label: 'İşlemler',
        edit: 'Düzenle',
        unlock: 'Kilidi aç',
        resetPassword: 'Şifreyi sıfırla',
        resetTwoFactor: "2FA'yı sıfırla",
      },
      fields: {
        email: 'E-posta',
        firstName: 'Ad',
        lastName: 'Soyadı',
        phone: 'Telefon',
        locale: 'Dil',
        role: 'Rol',
        isActive: 'Hesap aktif',
        selfRoleHint: 'Kendi rolünüzü değiştiremezsiniz.',
      },
      sheet: {
        createTitle: 'Kullanıcı ekle',
        createDescription: 'Hesap tek seferlik bir başlangıç ​​şifresi alıyor.',
        editTitle: 'Kullanıcıyı düzenle',
        editDescription: 'Ana verileri, rolü ve hesap durumunu ayarlayın.',
        passwordHint:
          'Başlangıç ​​şifresi kaydedildikten sonra bir kez gösterilir ve ilk oturum açtığınızda değiştirilmelidir.',
      },
      credentials: {
        title: 'Başlangıç şifresi',
        description: "{{email}}'ye bir kez devredin; bir daha gösterilmeyecek.",
        hint: 'Hesap ilk girişte bu şifreyi değiştirmelidir.',
      },
      toast: {
        created: 'Kullanıcı oluşturuldu.',
        updated: 'Kullanıcı kaydedildi.',
        unlocked: 'Hesabın kilidi açıldı.',
        twoFactorReset: 'İki faktörlü kimlik doğrulama sıfırlandı.',
      },
    },
    roles: {
      title: 'Roller ve izinler',
      subtitle:
        'Rol başına izin matrisi; değişiklikler bir sonraki oturum açma işleminde geçerli olur.',
      list: 'Roller',
      create: 'Rol ekle',
      error: 'Roller yüklenemedi.',
      ownerHint: 'Sahip rolü her zaman tüm izinlere sahiptir ve düzenlenemez.',
      permissionCount: '{{count}} izinleri seçildi',
      fields: {
        name: 'Ad',
        description: 'Açıklama',
      },
      matrix: {
        resource: 'Alanı',
        toggleRow: '{{resource}} için tüm izinler',
      },
      resources: {
        FEATURES: 'Özellikler ve modüller',
        CUSTOMERS: 'Müşteriler',
        PARTNER_RISK: 'Müşteri riski ve kilitler',
        PRODUCTS: 'Ürünler',
        BATCHES: 'Partiler ve stok',
        DOCUMENTS: 'Belgeler',
        DOCUMENT_CUSTOMER_HEADERS: 'Belge başlıklarındaki müşteri verileri',
        DMS: 'Belge yönetimi',
        ACCOUNTING: 'Muhasebe',
        ANALYTICS: 'Raporlama',
        SETTINGS: 'Ayarlar',
        USERS: 'Kullanıcılar',
        TELEPHONY: 'Telefon ve Yapay Zeka',
        ANALYSIS: 'Analiz ve besin değeri profilleri',
        MANUFACTURING: 'Üretim',
        TRACEABILITY: 'Parti izlenebilirliği',
        MRP: 'Malzeme ihtiyaç planlaması',
        LABEL_MANAGEMENT: 'Etiket yönetimi',
        CUSTOM_FIELDS: 'Dinamik özel alanlar',
        INTRODUCTION: 'Devreye alma modu',
        SETUP: 'Kiracı kurulumu',
        BACKUPS: 'Yedekleme ve geri yükleme',
      },
      actions: {
        CREATE: 'Oluştur',
        READ: 'Oku',
        UPDATE: 'Güncelleme',
        DELETE: 'Sil',
        EXPORT: 'Dışa Aktar',
        APPROVE: 'Onayla',
        RELEASE: 'Üretim emrini serbest bırak',
        RESERVE: 'Malzeme rezerve et',
        CONSUME: 'Malzeme hareketi kaydet',
        COMPLETE: 'Üretimi tamamla',
        SIMULATE: 'Geri çağırmayı simüle et',
        BLOCK: 'Partileri bloke et',
        REVIEW: 'İncele',
        MANAGE: 'Yönet',
        ARCHIVE: 'Arşivle',
        ADMIN: 'Yönet',
        USE: 'Arama yapın',
        VIEW: 'Riski görüntüle',
        SET_LOCK: 'Kilidi uygula',
        OVERRIDE_LOCK: 'Kilidi serbest bırak',
        VIEW_OWN_LOGS: 'Kendi aramaları',
        VIEW_ALL_LOGS: 'Tüm aramalar',
        VIEW_AI_SUMMARY: 'Yapay zeka analizini görüntüle',
        EDIT_AI_SUMMARY: 'Yapay zeka analizini düzenle',
        MANAGE_SETTINGS: 'Ayarları yönet',
        VIEW_COSTS: 'Maliyetleri görüntüle',
        RUN: 'Planlamayı çalıştır',
        CONFIGURE: 'Yapılandır',
        CONVERT_PURCHASE: 'Satın alma taslağı oluştur',
        CONVERT_PRODUCTION: 'Üretim taslağı oluştur',
        IMPORT: 'Toplu içe aktarma yap',
        ROLLBACK: 'Sürümü geri yükle',
        MANAGE_FIELDS: 'Alanları yönet',
        MANAGE_GROUPS: 'Kategorileri yönet',
        READ_CONFIDENTIAL: 'Gizli alanları oku',
        WRITE_CONFIDENTIAL: 'Gizli alanları değiştir',
        VIEW_AUDIT: 'Değişiklik geçmişini görüntüle',
        CREATE_SETTINGS: 'Ayar yedeği oluştur',
        CREATE_MASTER_DATA: 'Ana veri yedeği oluştur',
        CREATE_FULL: 'Tam yedek oluştur',
        DOWNLOAD: 'Yedeği indir',
        RESTORE: 'Yedeği geri yükle',
        RESTORE_DRY_RUN: 'Geri yükleme denemesi',
        VIEW_DEPLOYMENT: 'Dağıtım yedeklerini görüntüle',
        DELETE_DETAILS: 'Müşteri ayrıntılarını sil',
        EDIT_PRICES: 'Fiyat ve indirimleri değiştir',
        CANCEL: 'Belgeleri iptal et',
      },
      delete: {
        title: 'Rolü sil',
        description: '“{{name}}” rolü kalıcı olarak kaldırılacak.',
      },
      toast: {
        created: 'Rol oluşturuldu.',
        updated: 'Rol kaydedildi.',
        deleted: 'Rol silindi.',
      },
    },
    profile: {
      title: 'Profilim',
      subtitle: 'Kişisel ayrıntılar ve dil tercihi.',
      account: 'Hesap',
      emailChangeHint:
        'Yeni e-posta adresi mevcut parolanızı gerektirir ve yeniden doğrulanana kadar e-posta 2FA’yı devre dışı bırakır.',
      role: 'Rol',
      tenant: 'Kiracı',
      saved: 'Profil kaydedildi.',
    },
    security: {
      title: 'Güvenlik',
      subtitle: 'Şifre, ikinci faktör ve aktif oturumlar.',
      password: {
        title: 'Şifreyi değiştir',
        description: 'Büyük ve küçük harf, rakam ve sembolden oluşan en az 12 karakter.',
        current: 'Mevcut şifre',
        new: 'Yeni şifre',
        confirm: 'Yeni şifreyi onayla',
        mismatch: 'Şifreler eşleşmiyor.',
        submit: 'Şifreyi değiştir',
        changed: 'Şifre değiştirildi.',
        show: 'Şifreyi göster',
        hide: 'Şifreyi gizle',
        strengthLabel: 'Şifre gücü',
        strength: {
          '0': 'Çok zayıf',
          '1': 'Zayıf',
          '2': 'Fuar',
          '3': 'Güçlü',
          '4': 'Çok güçlü',
        },
        rules: {
          length: 'En az 12 karakter',
          uppercase: 'Bir büyük harf',
          lowercase: 'Bir küçük harf',
          digit: 'Bir rakam',
          special: 'Bir sembol',
        },
      },
      forceChange: {
        title: 'Şifre değişikliği gerekli',
        description:
          'Hesabınız bir başlangıç şifresiyle oluşturuldu. Lütfen şimdi kendi şifrenizi seçin.',
      },
      twoFactor: {
        title: 'İki faktörlü kimlik doğrulama',
        description: 'Kimlik doğrulama uygulaması (TOTP) aracılığıyla ek koruma.',
        active: 'Etkin',
        inactive: 'Devre Dışı',
        enable: 'Etkinleştir',
        disable: 'Devre Dışı Bırak',
        enableTitle: 'İki faktörlü kimlik doğrulamayı ayarla',
        disableTitle: 'İki faktörlü kimlik doğrulamayı devre dışı bırak',
        disableDescription: 'Onaylamak için şifreniz ve geçerli bir kod gereklidir.',
        intro:
          '1Password, Aegis veya Google Authenticator gibi bir kimlik doğrulama uygulamasına ihtiyacınız var.',
        start: 'Kurulumu başlat',
        steps: {
          scan: 'Adım 1/3: kurulumu başlatın.',
          verify: 'Adım 2/3: QR kodunu tarayın ve kodu girin.',
          codes: 'Adım 3/3: Yedek kodları saklayın.\nKimlik doğrulayıcı uygulamasını kurmak için',
        },
        qrAlt: 'QR kodu',
        enterCode: 'Uygulamadan kodu girin',
        code: 'Doğrulama kodu',
        backupHint:
          'Cihazınızı kaybederseniz bu kodlar ikinci faktörün yerine geçer. Her kod bir kez çalışır.',
        downloadCodes: 'Yedek kodları indir',
        enabled: 'İki faktörlü kimlik doğrulama etkinleştirildi.',
        disabled: 'İki faktörlü kimlik doğrulama devre dışı.',
        authenticator: 'Kimlik doğrulama uygulaması (TOTP)',
        makePrimary: 'Tercih edilen yap',
      },
      emailTwoFactor: {
        title: 'E-posta kodunu etkinleştir',
        disableTitle: 'E-posta kodunu devre dışı bırak',
        method: 'E-posta kodu',
        description: 'Önce parolanızı, ardından e-postadaki kodu doğrulayın.',
        disableDescription: 'Parolanızı ve güncel bir doğrulayıcı veya yedek kodu girin.',
        secondFactor: 'Doğrulayıcı veya yedek kod',
        sentTo: '{{email}} adresine bir güvenlik kodu gönderildi.',
        send: 'Kod gönder',
        confirm: 'Etkinleştir',
        enabled: 'E-posta 2FA etkinleştirildi.',
        disabled: 'E-posta 2FA devre dışı bırakıldı.',
        independenceWarning:
          'Kimlik doğrulama uygulaması, özellikle iki hesap aynı cihazda kullanılıyorsa e-postadan genellikle daha bağımsız ve güvenlidir.',
      },
      twoFactorPolicy: {
        title: 'Kiracı 2FA ilkesi',
        description: 'Bu kiracı için izin verilen yöntemleri ve zorunlulukları yönetin.',
        error: 'Güvenlik ilkesi yüklenemedi.',
        methods: { TOTP: 'Doğrulayıcı uygulamasına izin ver', EMAIL: 'E-posta koduna izin ver' },
        required: 'Tüm kullanıcılar için iki faktörlü doğrulamayı zorunlu kıl',
        emailEnabled: 'Bu kiracı için e-posta 2FA’yı etkinleştir',
        privilegedTotp: 'Ayrıcalıklı roller için TOTP zorunlu olsun',
        requiredRoles: '2FA gerektiren roller',
        roles: { OWNER: 'Sahip', ADMIN: 'Yönetici' },
        validity: 'E-posta kodu geçerliliği (dakika)',
        cooldown: 'Yeniden gönderme bekleme süresi (saniye)',
      },
      sessions: {
        title: 'Aktif oturumlar',
        description: 'Şu anda bu hesapla oturum açmış cihazlar.',
        empty: 'Aktif oturum yok.',
        error: 'Oturumlar yüklenemedi.',
        current: 'Bu oturum',
        unknownDevice: 'Bilinmeyen cihaz',
        revoke: 'İptal Et',
        revokeOthers: 'Diğer tüm oturumları iptal et',
        revoked: 'Oturum iptal edildi.',
        revokedOthers: 'Diğer tüm oturumlar iptal edildi.',
      },
    },
    securityLog: {
      title: 'Güvenlik günlüğü',
      subtitle: 'Oturum açmalar, izin değişiklikleri ve güvenlikle ilgili etkinlikler.',
      searchPlaceholder: 'E-posta veya IP adresini arayın',
      filterEvent: 'Olay filtresi',
      allEvents: 'Tüm etkinlikler',
      empty: 'Seçilen filtreler için giriş yok.',
      error: 'Günlük yüklenemedi.',
      columns: {
        timestamp: 'Zaman Damgası',
        event: 'Etkinlik',
        user: 'Kullanıcı',
        ip: 'IP adresi',
      },
      events: {
        LOGIN_SUCCESS: 'Oturum açma başarılı',
        LOGIN_FAILED: 'Oturum açma başarısız oldu',
        LOGOUT: 'Oturumu kapat',
        TWO_FACTOR_ENABLED: '2FA etkin',
        TWO_FACTOR_DISABLED: '2FA devre dışı',
        TWO_FACTOR_FAILED: '2FA başarısız oldu',
        TWO_FACTOR_METHOD_CHANGED: '2FA yöntemi değiştirildi',
        TWO_FACTOR_RESET: '2FA sıfırlandı',
        EMAIL_CHANGED: 'E-posta adresi değiştirildi',
        PASSWORD_CHANGED: 'Şifre değiştirildi',
        PASSWORD_RESET: 'Şifre sıfırlama',
        ACCOUNT_LOCKED: 'Hesap kilitlendi',
        ACCOUNT_UNLOCKED: 'Hesabın kilidi açıldı',
        ROLE_UPDATED: 'Rol değişti',
        PERMISSIONS_MODIFIED: 'İzinler değiştirildi',
        SESSION_REVOKED: 'Oturum iptal edildi',
        USER_CREATED: 'Kullanıcı oluşturuldu',
        USER_UPDATED: 'Kullanıcı güncellendi',
      },
    },
    notifications: {
      title: 'Bildirimler',
      bell: 'Bildirimleri aç',
      bellWithCount: '{{count}} okunmamış bildirimler',
      unread: 'Okunmamış',
      open: 'Aç',
      markAllRead: 'Tümünü okundu olarak işaretle',
      manage: 'Bildirimleri yönet',
      error: 'Bildirimler yüklenemedi.',
      tabs: {
        all: 'Hepsi',
        unread: 'Okunmamış',
        critical: 'Kritik',
      },
      empty: {
        title: 'Bildirim yok',
        description: 'Burada yeni etkinlikler gerçek zamanlı olarak görünüyor.',
      },
      categories: {
        STOCK_LOW: 'Seviyeyi yeniden sırala',
        BATCH_EXPIRING: 'Son kullanma uyarısı',
        ORDER_CREATED: 'Yeni düzen',
        INVOICE_OVERDUE: 'Vadesi geçmiş fatura',
        TASK_ASSIGNED: 'Takip',
        SYSTEM: 'Sistem',
      },
    },
    notificationSettings: {
      title: 'Bildirimler',
      subtitle: 'Hangi olayların size ve nereye ulaşacağına karar verin.',
      matrixTitle: 'Dağıtım kanalları',
      matrixDescription:
        'Zil, uygulama içindeki olayları anında bildirir, e-posta da size başka bir yerden ulaşır.',
      error: 'Ayarlar yüklenemedi.',
      autoSave: 'Değişiklikler hemen kaydedilir.',
      saved: 'Ayar kaydedildi.',
      columns: {
        event: 'Etkinlik',
        inApp: 'Uygulama içi zil',
        email: 'Anında e-posta',
      },
      descriptions: {
        STOCK_LOW: 'Bir makalenin stoğu yeniden sipariş düzeyine ulaştı.',
        BATCH_EXPIRING: 'Bir grubun süresi önümüzdeki 30 gün içinde doluyor.',
        ORDER_CREATED: 'Yeni bir sipariş geldi veya onaylandı.',
        INVOICE_OVERDUE: 'Bir fatura son ödeme tarihinin ötesinde açıktır.',
        TASK_ASSIGNED: 'Size takip içeren bir çağrı notu atandı.',
        SYSTEM: 'Bu kiracının güvenlik ve sistem olayları.',
      },
    },
    company: {
      title: 'Şirket',
      subtitle: 'Ana veriler, banka ayrıntıları ve belge temerrütleri.',
      error: 'Şirket verileri yüklenemedi.',
      saved: 'Şirket verileri kaydedildi.',
      invalid: 'Lütfen vurgulanan alanları inceleyin.',
      sections: {
        identity: 'Şirket',
        identityHint: 'Bu ayrıntılar belgenin üstbilgisinde ve altbilgisinde görünür.',
        tax: 'Vergi ve bankacılık',
        taxHint: '§ 14 UStG uyarınca zorunlu ayrıntılar artı faturalar için banka hesabı.',
        layout: 'Belge düzeni',
        layoutHint: "Logo ve vurgu rengi, oluşturulan her PDF'de görünür.",
        documents: 'Belge varsayılanları',
        documentsHint: 'Yeni teklifler ve faturalar için ön ayarlar.',
      },
      fields: {
        companyName: 'Şirket adı',
        legalForm: 'Yasal form',
        ownerName: 'Sahip / genel müdür',
        street: 'Sokak ve numara',
        zip: 'Posta kodu',
        city: 'Şehir',
        country: 'Ülke',
        phone: 'Telefon',
        email: 'E-posta',
        website: 'Web sitesi',
        vatId: 'KDV Numarası',
        taxNumber: 'Vergi numarası',
        commercialRegister: 'Ticaret sicili',
        commercialRegisterHint: 'ör. HRB 12345, Amtsgericht Stuttgart',
        bankName: 'Banka',
        iban: 'IBAN',
        bic: 'BIC',
        primaryColor: 'Ana renk',
        invoiceDueDays: 'Gün olarak ödeme süresi',
        quoteValidityDays: 'Teklifin gün cinsinden geçerliliği',
        defaultEmailSender: 'Belgeler için gönderen adresi',
        defaultEmailSenderHint: 'Belgeleri gönderirken yanıt adresi olarak kullanılır.',
      },
      legalForms: {
        EINZELUNTERNEHMEN: 'Şahıs mülkiyeti',
        FREIBERUFLER: 'Serbest Çalışan',
        EK: 'e. K.',
        GBR: 'GbR',
        OHG: 'OHG',
        KG: 'KG',
        GMBH: 'GmbH',
        GMBH_CO_KG: 'GmbH & Co. KG',
        UG: 'UG (sınırlı sorumluluk)',
        AG: 'AG',
        SE: 'SE',
        EG: 'eG',
        LTD: 'Ltd.',
        GESMBH: 'GesmbH (Avusturya)',
        AG_CH: 'AG (İsviçre)',
        SONSTIGE: 'Diğer',
      },
      logo: {
        empty: 'Logo yok',
        preview: 'Logo önizlemesi',
        select: 'Logoyu seç',
        remove: 'Logoyu kaldır',
        hint: "{{size}} KB'ye kadar PNG, JPEG veya SVG.",
        invalidType: "İzin verilen formatlar PNG, JPEG ve SVG'dir.",
        tooLarge: "Dosya {{size}} KB'yi aşıyor.",
      },
      color: {
        custom: 'Özel bir renk seç',
        previewTitle: 'Fatura RE-2026-00001',
        previewHint: 'Belge başlığı ve tablo kuralları',
      },
    },
    accounting: {
      periods: {
        lastMonth: 'Geçen ay',
        currentMonth: 'Mevcut ay',
        q1: '1. Çeyrek',
        q2: '2. Çeyrek',
        q3: '3. Çeyrek',
        q4: '4. Çeyrek',
        currentYear: 'Cari yıl',
        custom: 'Özel aralık',
        from: 'Başlangıç',
        to: 'Bitiş',
      },
      months: {
        '1': 'Ocak',
        '2': 'Şubat',
        '3': 'Mart',
        '4': 'Nisan',
        '5': 'Mayıs',
        '6': 'Haziran',
        '7': 'Temmuz',
        '8': 'Ağustos',
        '9': 'Eylül',
        '10': 'Ekim',
        '11': 'Kasım',
        '12': 'Aralık',
      },
      federalStates: {
        '01': 'Schleswig-Holstein',
        '02': 'Hamburg',
        '03': 'Aşağı Saksonya',
        '04': 'Bremen',
        '05': 'Kuzey Ren-Vestfalya',
        '06': 'Hesse',
        '07': 'Renanya-Pfalz',
        '08': 'Baden-Württemberg',
        '09': 'Bavyera',
        '10': 'Saarland',
        '11': 'Berlin',
        '12': 'Brandenburg',
        '13': 'Mecklenburg-Batı Pomeranya',
        '14': 'Saksonya',
        '15': 'Saksonya-Anhalt',
        '16': 'Thüringen',
      },
      natureOfTransaction: {
        '11': 'Kesin alım/satış',
        '12': 'Onaylanan veya deneme aşamasında olan ürünler',
        '21': 'Malların iadesi',
        '22': 'İade edilen malların değiştirilmesi',
        '23': 'İade edilmeyen malların değiştirilmesi',
        '31': 'Yardım programları kapsamında teslimat',
        '41': 'İşleniyor, geri dönüş bekleniyor',
        '51': 'İşlendikten sonra geri dön',
        '91': '24 ay boyunca işe alın, ödünç verin veya kiralayın',
        '99': 'Diğer işlemler',
      },
      modeOfTransport: {
        '1': 'Deniz taşımacılığı',
        '2': 'Demiryolu taşımacılığı',
        '3': 'Karayolu taşımacılığı',
        '4': 'Hava taşımacılığı',
        '5': 'Posta gönderisi',
        '7': 'Sabit taşıma kurulumları',
        '8': 'İç su yolu',
        '9': 'Kendi itiş gücü',
      },
      datev: {
        title: 'DATEV dışa aktarımı',
        subtitle: 'Vergi danışmanına devredilmek üzere EXTF rezervasyon grubu.',
        openSettings: 'Yapılandırma',
        periodSection: 'Dönem ve belge seçimi',
        reconciliation: 'Mutabakat: borç {{debit}} · alacak {{credit}}',
        tabs: {
          export: 'Dışa Aktar',
          history: 'Dışa aktarma geçmişi',
        },
        filters: {
          includeCancellations: 'İptal faturalarını ve alacak dekontlarını dahil et',
          includeAlreadyExported:
            'Halihazırda dışa aktarılan belgeleri dahil et (tekrar çalıştırma)',
        },
        kpi: {
          records: 'Rezervasyon kayıtları',
          documents: 'Belgeler',
          net: 'Net hacim',
          gross: 'Brüt hacim',
        },
        columns: {
          date: 'Belge tarihi',
          number: 'Belge no.',
          customer: 'Müşteri',
          account: 'Hesap',
          contraAccount: 'Kontra hesabı',
          buKey: 'Vergi anahtarı',
          net: 'Net',
          tax: 'KDV',
          gross: 'Brüt',
          debitCredit: 'D/C',
          state: 'Durum',
        },
        state: {
          locked: 'Gönderildi',
          open: 'Aç',
        },
        states: {
          empty: 'Seçilen dönemde dışa aktarılabilir belge yok.',
        },
        validation: {
          clean: 'Döneme ait tüm belgeler ihracata hazır.',
          invalidRange: 'Başlangıç ​​tarihi bitiş tarihinden sonra olmamalıdır.',
          openCustomer: 'Açık müşteri',
          openDocument: '{{number}} dokümanını aç',
        },
        issues: {
          DEBTOR_ACCOUNT_MISSING_one: 'Borçlu hesabı olmayan {{count}} belgesi.',
          DEBTOR_ACCOUNT_MISSING_other: '{{count}} borçlu hesabı olmayan belgeler.',
          REVENUE_ACCOUNT_MISSING_one: 'Eşlenen gelir hesabı olmayan {{count}} belgesi.',
          REVENUE_ACCOUNT_MISSING_other: '{{count}} eşlenen gelir hesabı olmayan belgeler.',
          VAT_ID_MISSING_one: '{{count}} müşteri KDV Numarası olmadan sıfır oranlı AB tedariki.',
          VAT_ID_MISSING_other:
            '{{count}}, müşterinin KDV Numarası olmayan sıfır oranlı AB tedarikleri.',
          DOCUMENT_NOT_LOCKED_one:
            '{{count}} belgesi henüz yayınlanmadı ve dışa aktarma sırasında yayınlanacak.',
          DOCUMENT_NOT_LOCKED_other:
            '{{count}} belgeleri henüz gönderilmedi ve dışa aktarma sırasında yayınlanacak.',
          DOCUMENT_ALREADY_EXPORTED_one: '{{count}} belgesi zaten teslim edildi.',
          DOCUMENT_ALREADY_EXPORTED_other: '{{count}} belgeleri zaten teslim edildi.',
          SETTINGS_INCOMPLETE_one: 'Danışman ve müşteri numarası yapılandırmada eksik.',
          SETTINGS_INCOMPLETE_other: 'Danışman ve müşteri numarası yapılandırmada eksik.',
          AMOUNT_ZERO_one: '{{count}} belgesinde herhangi bir miktar içeren satır yok.',
          AMOUNT_ZERO_other: '{{count}} herhangi bir tutar içeren satır içermeyen belgeler.',
        },
        export: {
          action: 'Rezervasyon grubunu dışa aktar (.csv)',
          success: 'Rezervasyon grubu oluşturuldu ve indirildi.',
        },
        history: {
          exportedAt: 'Dışa aktarılma tarihi',
          period: 'Dönem',
          filename: 'Dosya',
          records: 'Kayıtlar / belgeler',
          volume: 'Brüt hacim',
          checksum: 'Sağlama Toplamı',
          download: 'Tekrar indir',
          repeat: 'Tekrarla',
          empty: 'Henüz hiçbir rezervasyon partisi dışa aktarılmadı.',
          hint: 'Sağlama toplamı, yenilenen dosyanın arşivlenen çalıştırmayla eşleştiğini kanıtlar.',
        },
      },
      settings: {
        title: 'Muhasebe yapılandırması',
        subtitle: 'Hesap planı, DATEV ana verileri ve Intrastat varsayılanları.',
        chartSection: 'Hesap planı ve DATEV ana verileri',
        mappingSection: 'Vergi vakasına göre gelir hesapları',
        intrastatSection: 'Intrastat varsayılanları',
        saved: 'Ayarlar kaydedildi.',
        charts: {
          SKR03: 'Süreç bazlı; 8000–8999 aralığında gelir hesapları.',
          SKR04: 'Bilanço bazlı; 4000–4999 aralığında gelir hesapları.',
        },
        fields: {
          consultantNumber: 'Danışman numarası',
          clientNumber: 'Müşteri numarası',
          fiscalYearStart: 'Mali yılın başlangıcı',
          accountNumberLength: 'Hesap numarası uzunluğu',
          debtorAccountRangeStart: 'Borçlu aralığı başlangıcı',
          dictationKey: 'Dikte tuşu',
          reportingVatId: 'Beyan sahibinin KDV numarası',
          federalState: 'Federal eyalet',
          natureOfTransaction: 'İşlemin varsayılan niteliği',
          modeOfTransport: 'Varsayılan taşıma modu',
        },
        mapping: {
          case: 'Vergi davası',
          account: 'Gelir hesabı',
          buKey: 'Vergi anahtarı',
          accountFor: '{{case}} için gelir hesabı',
          buKeyFor: '{{case}} için vergi anahtarı',
          automatic: 'Otomatik',
        },
        revenueCases: {
          DOMESTIC_STANDARD: { label: 'Yerli 19 %', hint: "Almanya'da standart ücret." },
          DOMESTIC_REDUCED: { label: 'Yerli 7 %', hint: "Almanya'da indirimli oran." },
          DOMESTIC_EXEMPT: { label: 'Yurtiçi muafiyet', hint: 'Sıfır dereceli yurt içi ciro.' },
          INTRA_COMMUNITY: {
            label: 'AB sıfır dereceli',
            hint: 'Topluluk içi tedarik, sn. 4 hayır. 1b UStG.',
          },
          EXPORT_NON_EU: { label: 'AB dışı ihracat', hint: 'İhracat arzı, sn. 4 hayır. 1a UStG.' },
          REVERSE_CHARGE: {
            label: 'Ters şarj',
            hint: 'Alıcının KDV borcu vardır, sn. 13b UStG.',
          },
        },
        debtors: {
          action: 'Borçlu hesaplarını atayın',
          assigned_one: '{{count}} borçlu hesabı atandı.',
          assigned_other: '{{count}} borçlu hesapları atandı.',
        },
      },
      intrastat: {
        title: 'Intrastat beyanı',
        subtitle: 'Referans ayı başına diğer AB üye ülkelerine gönderim yapılır.',
        periodSection: 'Raporlama dönemi',
        fields: {
          year: 'Raporlama yılı',
          month: 'Referans ayı',
          direction: 'Akış',
        },
        directions: {
          DISPATCH: 'Gönderim',
          ARRIVAL: 'Varış',
        },
        kpi: {
          value: 'Faturalanan tutar',
          weight: 'Net kütle',
          positions: 'Bildirilen kalemler',
        },
        columns: {
          commodityCode: 'Ürün kodu (CN8)',
          destination: 'Hedef',
          origin: 'Menşe ülke',
          nature: 'İşlemin niteliği',
          transport: 'Taşıma şekli',
          weight: 'Net kütle',
          invoiced: 'Faturalanan tutar',
          statistical: 'İstatistiksel değer',
          partnerVatId: 'İş Ortağı KDV Numarası',
        },
        issueFields: {
          commodityCode: 'Mal kodu eksik veya 8 haneli değil',
          countryOfOrigin: 'Menşe ülkesi eksik',
          netWeight: 'Net ağırlık eksik',
          destinationCountry: 'Hedef ülke eksik',
        },
        readiness: {
          clean: 'Bildirime tabi tüm kalemler eksiksiz.',
          blocked_one: '{{count}} ürünü bildirimi engelliyor.',
          blocked_other: '{{count}} ürünleri bildirimi engelliyor.',
          openProduct: 'Ürünü aç',
        },
        states: {
          empty: 'Bu referans ayı için bildirilebilir gönderim yok.',
        },
        export: {
          csv: 'Kontrol listesi (.csv)',
          xml: 'IDEV için INSTAT/XML',
          success: 'Beyan dosyası oluşturuldu ve indirildi.',
        },
      },
    },
  },
} as const;
